import axios from '@/lib/axios';
import { Product } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0410. 売上カテゴリ登録
 * [POST] /workspaces/:identifier/products
 */
type Props = {
  identifier: string;
  name: string;
  description?: string;
  spot_available: boolean;
  spot_amount?: number;
  monthly_available: boolean;
  monthly_amount?: number;
  contract_term_available: boolean;
  delivery_date_available: boolean;
};
const createProduct = (props: Props): Promise<Product> => {
  return axios.post(`/api/workspaces/${props.identifier}/products`, props);
};

export const useCreateProduct = () => {
  return useMutation({
    mutationFn: createProduct,
  });
};
